import { useFormikContext } from "formik";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import useGetData from "../../api/useGetData";
import SelectInput from "../../common/SelectInput";
import alphabeticalSort from "../../utils/alphabeticalSort";

/**
 * A component that renders a select input for the nationality.
 * The main reason that it is put in a separate component to use the convenient useFormikContext, which helps to update the options when the language changes
 *
 * @returns {JSX.Element}
 */

const NationalitySelect = () => {
  const { setFieldValue } = useFormikContext();
  const {
    data: nationaliyData,
    getData: getNationalityData,
    loading: loadingNationality,
  } = useGetData({
    route: "api/method/airport_transport.api.user.get_nationality",
  });
  const {
    t,
    i18n: { language },
  } = useTranslation("global");
  const { getData: getUserInfo, loading: loadingUserInfo } = useGetData({
    route: "api/method/airport_transport.api.user.get_user_info",
  });
  const nationalities = [...nationaliyData].sort(alphabeticalSort);
  useEffect(() => {
    if (!loadingNationality && !loadingUserInfo) {
      getNationalityData({ params: {} });
      getUserInfo({ params: {} }).then((userInfo) => {
        setFieldValue("nationality", userInfo.data.data.nationality);
      });
    }
  }, [language]);

  return (
    <SelectInput
      name="nationality"
      onChange={(value) => setFieldValue("nationality", value)}
      label={t("my_profile.nationality_text")}
      placeholder={t("select_nationality")}
      options={nationalities?.map((n) => ({
        value: n,
        label: n,
      }))}
    />
  );
};

export default NationalitySelect;
